<div class="dismissible-banner" [class.variant-success]="variant === 'success'" [class.is-top]="position === 'top'">
  <ion-icon [name]="icon" class="banner-icon"></ion-icon>
  <div class="banner-text">
    <strong>{{ title }}</strong>
    <span>{{ subtitle }}</span>
  </div>
  <ion-button size="small" (click)="action.emit()">{{ actionLabel }}</ion-button>
  <ion-button class="dismiss-btn" fill="clear" size="small" (click)="dismissed.emit()" aria-label="Cerrar">
    <ion-icon slot="icon-only" name="close-outline"></ion-icon>
  </ion-button>
</div>
